/* <lp-compare-board> — mobile tabs that swap which rival is compared against your brand. */
(function () {
  'use strict';
  class LPCompareBoard extends HTMLElement {
    connectedCallback() {
      const board = this.querySelector('.lp-cmp__board');
      const tabs = Array.from(this.querySelectorAll('.lp-cmp__tab'));
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => {
            const on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', String(on));
          });
          if (board) board.setAttribute('data-rival', tab.dataset.rival);
        });
      });
    }
  }
  if (!customElements.get('lp-compare-board')) customElements.define('lp-compare-board', LPCompareBoard);
})();